import React from 'react';
import { CheckCircle2, Clock, Circle, ChevronRight } from 'lucide-react';

export default function ProductionPipeline({ stages, batches }) {
  if (!stages?.length) return null;

  return (
    <>
      <p className="text-[10px] text-slate-400 uppercase tracking-wider mb-2">Production Pipeline</p>
      <div className="flex items-center gap-1 flex-wrap mb-3">
        {stages.map((stage, si) => {
          const stageCompleted = batches?.every(b => b.status === 'completed' || (b.current_stage_index != null && b.current_stage_index > si));
          const stageActive = batches?.some(b => ['in_progress', 'pending'].includes(b.status) && b.current_stage_index != null && b.current_stage_index === si);
          return (
            <React.Fragment key={si}>
              <div className="flex items-center gap-1" title={stage.stage_name}>
                {stageCompleted ? (
                  <CheckCircle2 className="h-3.5 w-3.5 text-green-500" />
                ) : stageActive ? (
                  <Clock className="h-3.5 w-3.5 text-brand-gold-deep" />
                ) : (
                  <Circle className="h-3.5 w-3.5 text-slate-300" />
                )}
                <span className={`text-[10px] ${stageCompleted ? 'text-green-600' : stageActive ? 'text-brand-gold-deep font-medium' : 'text-slate-400'}`}>
                  {stage.stage_name}
                </span>
              </div>
              {si < stages.length - 1 && <ChevronRight className="h-3 w-3 text-slate-300" />}
            </React.Fragment>
          );
        })}
      </div>
    </>
  );
}
